import React, { useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import PdfFullScreenViewer from 'components/PdfFullScreenViewer'
import ImageViewer from 'components/ImageViewer'
import { getFileUrls } from 'services/fileService'

const isPdf = s => /\.pdf/i.test(s || '')
const isImage = s => /\.(jpg|jpeg|png|gif|svg|webp|avif)$/i.test(s || '')

const useFilePreview = (bpId) => {
  const [previewFile, setPreviewFile] = useState(null)
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewingId, setPreviewingId] = useState(null)

  const open = useCallback((file) => {
    const fileId = file?.id
    if (!fileId || previewingId) return
    setPreviewingId(fileId)
    getFileUrls(bpId, fileId)
      .then(res => {
        const urls = res?.data?.data || res?.data || {}
        const fileUrl = urls.url || ''
        const fileName = file.displayName || ''
        const originalPath = (urls.originalUrl || '').split('?')[0]
        if (isImage(fileName) || isImage(originalPath)) {
          setPreviewFile({ ...file, url: urls.originalUrl || fileUrl, originalUrl: urls.originalUrl, kind: 'image' })
          setPreviewOpen(true)
        } else if (isPdf(fileUrl) || isPdf(fileName)) {
          setPreviewFile({ ...file, url: fileUrl, originalUrl: urls.originalUrl, kind: 'pdf' })
          setPreviewOpen(true)
        } else {
          window.open(urls.originalUrl || fileUrl, '_blank', 'noopener')
        }
      })
      .catch(() => toast.error('Could not open a preview for this file.'))
      .finally(() => setPreviewingId(null))
  }, [bpId, previewingId])

  const close = () => { setPreviewOpen(false); setPreviewFile(null) }

  const modal = (
    <>
      {previewFile?.kind === 'pdf' && (
        <PdfFullScreenViewer open={previewOpen} onClose={close} file={previewFile} />
      )}
      {previewFile?.kind === 'image' && (
        <ImageViewer open={previewOpen} onClose={close} file={previewFile} />
      )}
    </>
  )

  return { open, previewingId, modal }
}

export default useFilePreview
